import './styles.scss'

import { useCallback } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { DrawerState, ExpandableDrawer } from '@Components/expandable-drawer'
import { Button } from '@Components/common/button'
import { BUTTON_TYPE } from '@Components/common/types'
import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store.ts'

const CLASS_NAME = 'gby-k2g-leaving-drawer'

export type LeavingDrawerProps = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onLeaveSelect: () => void
}

export const LeavingDrawer = (props: LeavingDrawerProps) => {
  const hostConfig = useSelector((state: RootState) => state.hostConfig)

  const drawerOpenChangeHandler = useCallback(
    (open: boolean) => {
      props.onOpenChange(open)
    },
    [props],
  )

  const drawerLeaveChangeHandler = useCallback(() => {
    props.onLeaveSelect()
  }, [props])

  return (
    <Dialog.Root open={props.isOpen} onOpenChange={drawerOpenChangeHandler}>
      <Dialog.Description className={`${CLASS_NAME}__description`}>
        Exit Ticket Mode Confirmation
      </Dialog.Description>
      <ExpandableDrawer
        classPrefix={CLASS_NAME}
        hasCloseButton={true}
        scrollable={false}
        state={props.isOpen ? DrawerState.OPEN : DrawerState.CLOSED}
        onOpenChange={() => {}}
        onOpenAutoFocus={() => {}}>
        <div className={`${CLASS_NAME}__title`}>
          {hostConfig.config?.content.leavingTicketMode.title}
        </div>
        <div
          className={`${CLASS_NAME}__body`}
          dangerouslySetInnerHTML={{
            __html: hostConfig.config?.content.leavingTicketMode.body ?? '',
          }}></div>

        <div className={`${CLASS_NAME}__button-group`}>
          <div className={`${CLASS_NAME}__button-group-background`} />
          <Button
            text={hostConfig.config?.content.leavingTicketMode.leaveButton ?? 'Leave'}
            type={BUTTON_TYPE.SUBMIT}
            classPrefix={`${CLASS_NAME}-button`}
            onClick={drawerLeaveChangeHandler}
          />
          <Button
            text={hostConfig.config?.content.leavingTicketMode.stayButton ?? 'Stay'}
            classPrefix={`${CLASS_NAME}-button`}
            onClick={() => drawerOpenChangeHandler(false)}
          />
        </div>
      </ExpandableDrawer>
    </Dialog.Root>
  )
}
